import { render, staticRenderFns } from "./TripAdd.vue?vue&type=template&id=4c5503ee&"
import script from "./TripAdd.vue?vue&type=script&lang=ts&"
export * from "./TripAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports